import * as React from "react";
import { BaseIconAttributes } from "./types";

export const Check: React.FC<BaseIconAttributes> = ({
  width = "1em",
  height = "1em",
  mainColor = "currentColor",
  ...restProps
}) => (
  <svg
    {...restProps}
    fill="none"
    height={height}
    viewBox="0 0 10 9"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M9.91458 2.25005L4.12514 8.03934L0.0859375 4.00014L1.50015 2.58592L4.12516 5.21093L8.50038 0.835815L9.91458 2.25005Z"
      fill={mainColor}
      fillRule="evenodd"
    />
  </svg>
);
